import React from 'react';
import { filterOptionMore } from './styles.mod.scss';

export default function FilterOptionListMore({ expanded, showMore, showLess }) {
  return expanded ? (
    <div className={filterOptionMore} onClick={showLess}>
      View Less
    </div>
  ) : (
    <div className={filterOptionMore} onClick={showMore}>
      View More
    </div>
  );
}
